module.exports = __webpack_public_path__ + "media/images/ui__textArrowLeftLight--dark-0dcad921c0841b12d4a34f1619670725.png";